
interface QuickAction {
  label: string
  onClick: () => void
  icon: string
}

interface DashboardCardProps {
  icon: string
  title: string
  subtitle: string
  count?: number | string
  onClick: () => void
  variant?: 'primary' | 'secondary' | 'warning' | 'admin'
  className?: string
  quickActions?: QuickAction[]
}

function DashboardCard({ 
  icon, 
  title, 
  subtitle, 
  count, 
  onClick, 
  variant = 'primary',
  className = '',
  quickActions = []
}: DashboardCardProps) {
  return (
    <div 
      className={`dashboard-card dashboard-card--${variant} ${className}`}
      onClick={onClick}
    >
      <div className="dashboard-card__header">
        <div className="dashboard-card__icon">
          {icon}
        </div>
        {count !== undefined && (
          <div className="dashboard-card__count">
            {count}
          </div>
        )}
      </div>
      <div className="dashboard-card__content">
        <h3 className="dashboard-card__title">{title}</h3>
        <p className="dashboard-card__subtitle">{subtitle}</p>
        
        {quickActions.length > 0 && (
          <div className="dashboard-card__quick-actions">
            {quickActions.map((action, index) => (
              <button
                key={index}
                className="quick-action-btn-small"
                onClick={(e) => {
                  e.stopPropagation()
                  action.onClick()
                }}
              >
                {action.icon} {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
      <div className="dashboard-card__action">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </div>
  )
}

export default DashboardCard